import React, { useState } from 'react';
import { ICartItem } from '../../../interfaces';
import { getLocalData } from '../../../domain/shopping-cart-address-provider';
import { removeCartItem } from '../../../data/data-service';
import { rootActions, useAppDispatch, useAppSelector } from '../../../data/store';
import { undoCartItem } from '../../../domain/undo-cart-item-provider';
import Preloader from '../../../../../../ui/svg/common/preloader';
import { sendGAEvent } from '../../../../../../domain/marketing/gtm-provider';

interface IRemoveCartItemBtn{
    cartItem: ICartItem,
    classes?: string,
}

const RemoveCartItemBtn = (props: IRemoveCartItemBtn) => {

    const { cartItem } = props;

    const dispatch = useAppDispatch();

    const[loading, setLoading] = useState(false);

    const cartStep = useAppSelector(store => store.root.cartStep);

    /**
     * remove cart item
     */
    const removeCartItemHandler = async () => {

        setLoading(true);

        const response = await removeCartItem(
            props.cartItem.cartItemGUID,
            getLocalData(),
        );

        setLoading(false);

        if(!response || response.statusCode !== 200 || !response.data.isValid || !response.data.relatedData) return;

        dispatch(
            rootActions.setCartData(response.data.relatedData)
        );

        // handle 'undo cart items'
        dispatch(
            rootActions.main({
                removedItems: undoCartItem(props.cartItem) || [],
            })
        );

        sendGAEvent('Remove SKU', `Step ${ cartStep }`);
    };

    return (
        <>
            {
                !loading &&
                <button
                    data-cart-item-guid={ cartItem.cartItemGUID }
                    data-qa="cart-step1-remove-product"
                    type="button"
                    className={ props.classes }
                    onClick={ removeCartItemHandler }>Remove</button>
            }

            {
                loading &&
                <div
                    data-qa="cart-step1-remove-product-preloader"
                    className="flex justify-center items-center"
                    style={{
                        width: '53px',
                }}>
                    <Preloader width="20px" height="20px" color="#4f4f4f" />
                </div>
            }
        </>
    )
};

export default RemoveCartItemBtn;